import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom'; // Изменено на HashRouter
import { AdminAuthProvider, useAdminAuth } from './context/AdminAuth';
import { translations } from './context/i18n';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import TimelineSection from './components/TimelineSection';
import WhyUsSection from './components/WhyUsSection';
import PartnersSection from './components/PartnersSection';
import BlogSection from './components/BlogSection';
import Footer from './components/Footer';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import ApproachSection from './components/ApproachSection';
import WhatWeDoSection from './components/WhatWeDoSection';
import SolutionsPageSection from './components/SolutionsPageSection';
import PrinciplesSection from './components/PrincipleSection';
import IndustriesSection from './components/IndustriesSection';
import ChallengesSection from './components/ChallengesSection';
import UnitingSection from './components/UnitingSection';

// Админка
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPosts from './pages/admin/AdminPosts';
import AdminTranslations from './pages/admin/AdminTranslations';

// Защищённый роут
function ProtectedRoute({ children }) {
  const { admin, loading } = useAdminAuth();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Բեռնում...</div>;
  }

  if (!admin) {
    return <Navigate to="/admin/login" />;
  }

  return children;
}

export default function App() {
  return (
    <AdminAuthProvider>
      <HashRouter> {/* Изменено с BrowserRouter на HashRouter */}
        <Routes>
          {/* Админка */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="posts" element={<AdminPosts />} />
            <Route path="translations" element={<AdminTranslations />} />
          </Route>

          {/* Основной сайт */}
          <Route path="/*" element={<MainSite />} />
        </Routes>
      </HashRouter>
    </AdminAuthProvider>
  );
}

function MainSite() {
  const [lang, setLang] = useState('ARM');
  const [showScrollTop, setShowScrollTop] = useState(false);

  const toggleLang = (code) => {
    setLang(code);
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const t = translations[lang] || translations.ARM;

  return (
    <div className="min-h-screen bg-white font-sans text-slate-800">
      <Header t={t} lang={lang} toggleLang={toggleLang} />
      <main className="flex-grow">
        <HeroSection t={t} />
        <AboutSection t={t} />
        <ChallengesSection t={t} />
        <SolutionsPageSection t={t} />
        <IndustriesSection t={t} />
        <PrinciplesSection t={t} />
        {/* <PartnersSection t={t} /> */}
        <UnitingSection t={t} />
        <ApproachSection t={t} />
        <WhatWeDoSection t={t} />
        <TimelineSection t={t} />
        <WhyUsSection t={t} />
        <ProjectsSection t={t} />
        <BlogSection t={t} />
        <ContactSection t={t} />
      </main>
      <Footer t={t} language={lang} />
      
      {/* Кнопка скролла вверх */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-6 right-6 z-50 w-12 h-12 flex items-center justify-center bg-[#0FA4E8] hover:bg-[#0B3B6F] text-white shadow-lg transition-all duration-300 ${showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="18 15 12 9 6 15" />
        </svg>
      </button>
    </div>
  );
}